var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEasy(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.32133 18.4682C6.3882 18.7687 6.54536 19.0415 6.77171 19.2501C6.99806 19.4586 7.28278 19.593 7.58769 19.6352C7.89259 19.6773 8.20309 19.6252 8.47754 19.4859C8.75199 19.3465 8.97726 19.1266 9.12314 18.8555L11.7514 14.9659L17.9222 21.1367C18.0468 21.2613 18.1947 21.3602 18.3575 21.4276C18.5203 21.495 18.6948 21.5298 18.871 21.5298C19.0472 21.5298 19.2217 21.495 19.3845 21.4276C19.5473 21.3602 19.6952 21.2613 19.8198 21.1367L21.1365 19.8201C21.2611 19.6955 21.3599 19.5476 21.4274 19.3848C21.4948 19.222 21.5295 19.0475 21.5295 18.8713C21.5295 18.695 21.4948 18.5206 21.4274 18.3578C21.3599 18.195 21.2611 18.047 21.1365 17.9224L14.9657 11.7517L18.8804 9.12339C19.1515 8.97741 19.3714 8.75203 19.5107 8.4775C19.6499 8.20296 19.7019 7.89239 19.6596 7.58747C19.6173 7.28254 19.4828 6.99784 19.2741 6.77157C19.0653 6.5453 18.7924 6.38828 18.4919 6.32157L1.41187 1.41211L6.32133 18.4682Z",
    stroke: "#01A0A0",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEasy);
export default __webpack_public_path__ + "static/media/easy.b3cd2afaef3c998f4c16f336bfa1436c.svg";
export { ForwardRef as ReactComponent };